export default {
  publicity: {
    brief: {
      zh: "2022北京冬奥会期间，中央广播电视总台凭借媒体融合传播理念、先进赛事制播水平和创新技术手段，做好赛事转播报道工作。通过8K超高清制播及终端呈现平台、结合5G媒体技术应用、依托多种新型转播设备、利用“CMG媒体云”制作优势、围绕全媒体多平台传播矩阵，发挥超清化、移动化、智能化技术特点，实现“科技冬奥·8K看奥运”目标，全面展示精彩、非凡、卓越的奥林匹克新篇章。",
      en: "During the Beijing 2022 Olympic Winter Games, the China Media Group (CMG) will facilitate the successful broadcasting and coverage of the event through media convergence communication concepts, advanced production and broadcasting techniques, and innovative technology. It will leverage the 8K ultra-high-definition production, broadcasting and terminal platform, 5G media technology, and a variety of new broadcasting equipment. It will also take advantage of the “CMG Media Cloud”, focus on the onmi-media multi-platform communication matrix, and utilize the ultra-high-definition, mobile and intelligent technology to showcase an extraordinary new chapter of Olympic Games history and achieve the goal: “Technology and the Winter Olympics - Watching the Olympics in 8K Ultra-high Definition”.",
    },
  },

  scene: [
    {
      id: "01",
      name: {
        zh: "赛场呈现",
        en: "Event Broadcasting",
        pic: "img/scene1/name.png",
      },
      icon: "icon-scene1",
      brief: {
        zh: "冬奥期间，总台承担“相约北京”冬季体育系列测试活动、火炬传递、冬奥会部分项目、冬残奥会的公共信号制作任务。其中，总台的超高清转播车系统及技术团队将为冬奥会速度滑冰和冬季两项公共信号制作提供技术支持。在开闭幕式、自由式滑雪大跳台、单板滑雪大跳台和速度滑冰项目中，总台的制作团队和技术设备将参与8K超高清公共信号制作，以国际水准展现“精彩”冬奥。",
        en: "During the Winter Olympics, the CMG will undertake public signal production for the “Experience Beijing” testing activities, featuring a series of winter sporting events, as well as the Olympic torch relay, several Winter Olympics projects and the Winter Paralympics. CMG’s ultra-high-definition OB van system and technology team will provide technological support for the production of public signals for speed skating and the biathlon. During the opening and closing ceremonies, the freestyle skiing Big Air event and the snowboarding Big Air event, CMG’s production team and its high-tech technical equipment will produce 8K ultra-high-definition public signals to present the “wonderful” Winter Olympics to meet international standards.",
      },
      title1: { zh: "先进的转播系统", en: "Advanced Broadcasting Equipment" },
      title2: { zh: "公共信号制作", en: "Public Signal Production" },
      head1: {
        zh: "“猎豹”4K超高速轨道拍摄系统",
        en: "4K ultra-high-speed track shooting system",
      },
      body1: {
        zh: "“猎豹”全称“超高速4K轨道摄像机系统”，是中央广播电视总台历时五年自主研发、拥有核心技术知识产权的360米U型超高速轨道拍摄系统，应用于2022冬奥会速度滑冰（大道速滑）项目公共信号制作。该系统采用直线电机驱动，并实现全4K图像拍摄。“猎豹”设计技术标准可达到25米/秒的高速度，3.5米/秒²的加减速性能，相当于90公里/小时。不仅能实时跟踪运动员的位置，还可以根据转播需求，实现加速、减速、超越等动作，灵活捕捉比赛画面。全套设备主要由轨道系统、电机系统、图像稳定5轴陀螺仪、4K图像及控制数据的微波传输系统、4K地面综合光传输系统等构成。",
        en: "The 350-meter U-shaped ultra-high-speed track shooting system CMG independently developed and boasts the intellectual property rights of the core technology will be used for the public signal production of speed skating events at the 2022 Winter Olympics. The system is driven by a linear motor, which can achieve a top speed of 25 meters per second, acceleration and deceleration performance of 3.5 meters per second squared and achieve the shooting with full 4K image quality. The complete set of equipment mainly consists of a track system, motor system, image stabilization 5-axis gyroscope, microwave transmission system for 4K image and control data and an integrated 4K ground optical transmission system.",
      },
      headClosing: {
        zh: "开闭幕式大屏播控",
        en: "4K ultra-high-speed track shooting system",
      },
      bodyClosing: {
        zh: "北京2022年冬奥会，总台派出技术团队承担冬奥会和冬残奥会开、闭幕式视频播控工作。总台大屏播控系统分为两部分，一是场地内演出大屏，包含地屏、冰立方、冰瀑等显示区域，主要配合播放演出的视频信号；二是观众席上方南、北两侧的大屏，主要播放OBS转播信号、插播短片和图文信息。该套大屏播放系统首次在世界最大的LED立体舞台应用，LED屏幕面积超过14000平方米，首次实现16K地屏视频的同步播放和主、备系统无缝切换，首次采用50P图像渲染技术制作视频内容，向全世界呈现了一场美妙绝伦的视觉盛宴，圆满完成了北京2022年冬奥会开闭幕式视频播控任务。",
        en: "The 350-meter U-shaped ultra-high-speed track shooting system CMG independently developed and boasts the intellectual property rights of the core technology will be used for the public signal production of speed skating events at the 2022 Winter Olympics. The system is driven by a linear motor, which can achieve a top speed of 25 meters per second, acceleration and deceleration performance of 3.5 meters per second squared and achieve the shooting with full 4K image quality. The complete set of equipment mainly consists of a track system, motor system, image stabilization 5-axis gyroscope, microwave transmission system for 4K image and control data and an integrated 4K ground optical transmission system.",
      },
      head2: {
        zh: "4K/8K超高清转播车",
        en: "4K/8K UHD OB van",
      },
      body2: {
        zh: "4K/8K超高清转播车车体为内外套双侧拉箱结构，全车长度13.75米，展开面积接近80平方米。全车由主制作区、副制作区、音频区、VE技术区、调光区、多功能区和强冷机柜区构成，最大可容纳36个工位。",
        en: "The body of the OB van is a double-sided pull box structure with inner and outer sleeves. The length of the body is 13.75 meters. The expansion area is close to 80 square meters. The vehicle consists of a main production area, auxiliary production area, audio area, VE technology area, dimming area, multi-functional area and a powerful machine cooling cabinet area that can accommodate up to 36 stations.",
      },
      head3: {
        zh: "4K/8K超高清外场箱载式转播系统",
        en: "4K/8K UHD EFP production system",
      },
      body3: {
        zh: "4K/8K超高清外场箱载式转播系统使用IP设备作为信号调度核心，基于SMPTE 2110协议完成视音频及辅助数据的传输，最大支持12路8K超高清信号的IP输入，6路8K超高清信号的IP输出，通过扩充板卡还可以增加输入输出规模，以满足更大规模的需求。",
        en: "The IP equipment is used as the signal scheduling center for the 4K/8K OB mounted broadcasting system to complete the transmission of video, audio and auxiliary data based on the SMPTE ST 2110. It supports a maximum of 12 IP input channels of 8K ultra-high-definition signals and 6 IP output channels of 8K ultra-high-definition signals. By expanding the board, we can increase the input and output channels to meet needs on a larger scale.",
      },
      head4: {
        zh: "三维声录音车",
        en: "3D audio recording vehicle",
      },
      body4: {
        zh: "三维声录音车采用IP化架构，能够同时满足高清和超高清电视节目录制所需的立体声、环绕声、三维声的音频信号制作，具有安全可靠的直播能力，能同时完成两套不同节目的录制，并能同时级联多台转播车。",
        en: "The 3D sound recording vehicle adopts IP architecture, which can simultaneously supply the audio signals in stereo, surround and 3D audio that are required for recording high-definition and ultra-high-definition TV programs. With a safe and reliable live broadcasting capability, the vehicle can simultaneously record two different programs and cascade multiple OB vans simultaneously.",
      },
      head5: {
        zh: "鸟巢国家体育场",
        en: "National Stadium (the Bird’s Nest)",
      },
      body5: {
        zh: "转播项目：开闭幕式8K公共信号制作<br>转播系统：A级4K/8K超高清转播车<br>转播要素：6讯道、8路8K上变换信号、1组（2路）字幕信号",
        en: "Broadcasting items: 8K public signal production for the opening and closing ceremonies<br>Broadcasting system: Class A 4K/8K UHD OB van<br>Broadcasting elements: 6 channels, 8 channels of 8K up-conversion signals, 1 group (2 channels) of subtitle signals",
      },
      head6: {
        zh: "冰丝带国家速滑馆",
        en: "National Speed Skating Oval (the Ice Ribbon)",
      },
      body6: {
        zh: "转播项目：速度滑冰4K和8K公共信号制作<br>转播系统：A级4K/8K超高清转播车、4K/8K超高清箱式转播系统<br>特种转播设备：4K超高速U型轨道摄像机、锥桶摄像机、鱼竿摄像机等",
        en: "Broadcasting items: 4K & 8K public signal production for speed skating<br>Broadcasting system: Class A 4K/8K UHD OB van, 4K/8K UHD EFP production system<br>Special broadcasting equipment: 4K ultra-high-speed U-shaped track camera, cone barrel camera, fishing rod camera, etc.",
      },
      head7: {
        zh: "首钢大跳台",
        en: "Big Air Shougang",
      },
      body7: {
        zh: "转播项目：单板式滑雪大跳台、自由式滑雪大跳台8K公共信号制作<br>转播系统：4K/8K超高清箱式转播系统<br>转播要素：6讯道、6路8K上变换信号、2组（4路）字幕信号",
        en: "Broadcasting items: 8K public signal production for snowboarding Big Air and freestyle skiing Big Air<br>Broadcasting system: 4K/8K UHD EFP production system<br>Broadcasting elements: 6 channels, 6 channels of 8K up-conversion signals, 2 groups (4 channels) of subtitle signals",
      },
      head8: {
        zh: "冬季两项中心",
        en: "National Biathlon Center",
      },
      body8: {
        zh: "转播项目：冬季两项4K公共信号制作<br>转播系统：2辆A级4K/8K超高清转播车<br>转播要素：44讯道，29路外来信号，8台12通道EVS，49个工位",
        en: "Broadcasting items: Biathlon 4K public signal production<br>Broadcasting system: 2 ClassA 4K/8K UHD OB van<br>Broadcasting elements: 44 channels, 29 external signals, 8 sets of 12-channel EVS, 49 stations",
      },
      head9: {
        zh: "VR公共信号制作",
        en: "VR Public Signal Production",
      },
      body9: {
        zh: "通过对国家速滑馆、CBD等代表性场所的拍摄，以航拍及定点拍摄等技术手段展示本届冬奥举办地的城市风貌。同时在正赛中参与VR信号的制作及转播，为观众带来身临其境的观赛体验。",
        en: "Through the shooting of representative places such as the National Speed Skating Oval and CBD, the urban style of the venue for the Beijing Winter Olympics will be demonstrated by aerial photography, fixed-point photography, etc. Meanwhile, we will participate in the production and broadcasting of VR signals during the event to bring the audience an immersive experience of watching the event.",
      },
      car_intro: {
        zh: "转播车系统内标配20个4K迅道，其中4K IP讯道能扩展至24个，若考虑基带讯道接入则最大可扩展至30个，辅助车还能提供额外8个讯道的接入；转播车和辅助车级联后最大可支持12个8K摄像机讯道；系统可接受多种格式的外来信号接入，包括高清基带信号、4×3G 4K基带信号、12G 4K基带信号，同时具备多路TICO浅压缩信号编解码交互能力，全车制作区监看支持HDR/ ITU BT.2020或SDR/ ITU BT.709；5级ME的切换台共支持80路4K信号输入，40路4K信号输出，在多级联动的工作模式下共支持20路8K信号输入，10路8K信号输出；该车系统采用SMPTE 2110协议作为系统IP传输协议，实现了视音频、通话及控制信号的全IP化，其信号完全通过IP业务交换机进行调度并支持SMPTE 2022-7协议实现主备IP信号无缝倒换。",
        en: "The OB van system is equipped with 20 4K channels, of which the number of 4K IP channels can be expanded to 24. If the baseband channel access is considered, the number of channels can be expanded to a maximum of 30. An additional 8 channels can be connected to the auxiliary vehicle. The OB van and the auxiliary vehicle can support up to 12 8K camera channels after being cascaded. The system can accept external signal access in various formats, including high-definition baseband signal, 4 × 3G 4K baseband signal and 12G 4K baseband signal. The system also boasts the interactive ability of coding and decoding multi-channel TICO mezzanine compression signals. The vehicle production area monitor supports HDR/ITU BT.2020 or SDR/ITU BT.709. The 5-stage M/E switching system supports a total of 80 input channels in 4K signal and 40 output channels in 4K signal. In the multi-stage linkage working mode, it also supports 20 input channels in 8K signal and 10 output channels in 8K signal. The SMPTE ST 2110 is adopted as the system IP transmission protocol, which is able to fully realize IP-based video, audio, tally and control signals. Its signals are completely scheduled by IP service switches. The SMPTE 2022-7 protocol is also supported to realize seamless switching between main and backup IP signals.",
      },
    },
    {
      id: "02",
      name: {
        zh: "8K制播与公共服务",
        en: "8K UHD Production & Broadcasting and Public Services",
        pic: "img/scene2/name.png",
      },
      icon: "icon-scene2",
      brief: {
        zh: "总台在北京冬奥会期间全面推进8K采、编、播、存全链路制播应用，承担北京冬奥会开闭幕式、自由式滑雪大跳台和单板滑雪大跳台、速度滑冰项目的8K公共信号制作任务，还对花样滑冰和短道速滑项目进行8K包装制作，为全球观众呈现丰富多彩的奥运盛宴。同时加快建设8K超高清电视公共服务平台，推动“百城千屏”8K超高清公共大屏服务和4K/8K超高清频道/点播入户服务，实现广播、电视、新媒体的深度融合和资源互补。",
        en: "During the 2022 Beijing Olympic Winter Games, 8K acquisition, editing, broadcasting and storage will be comprehensively promoted by China Media Group (CMG) throughout the entire production and broadcasting process. CMG will undertake the production of 8K public signals for the opening and closing ceremonies, freestyle skiing and snowboarding, and speed skating for the Olympic Winter Games. The group will also provide 8K packaging and production for figure skating and short track speed skating that will present a colorful Olympic feast for audiences around the world. CMG will also accelerate the construction of the 8K UHD TV public service platform, implement the “1,000 screens installed in 100 cities” 8K UHD public large screen service and 4K/8K UHD channel/on-demand service, and achieve the in-depth integration and resource balance of radio, TV and new media.",
      },
      head1: {
        zh: "总控超高清信号调度分发系统",
        en: "Master control system for UHD signal scheduling and distribution",
      },
      body1: {
        zh: "总台在北京冬奥会IBC和ZBC设立全媒体报道中心，满足前方节目制作和前后方信号调度、传输需求。总控系统按照超高清信号制作和传输要求进行全系统适配，满足前后方8K、4K和HD及新媒体信号的各频道、频率和新媒体平台的信号调度分发管理，打通前后方超大规模信号传输通道，实现总台首次外场大型体育赛事超高清、全IP化制播应用。",
        en: "For the Beijing Winter Olympics, CMG has set up all-media reporting centers at the IBC and ZBC workspace to meet the needs of on-site program production and front and rear signal scheduling and transmission. The master control system adapts according to the requirements of UHD signal production and transmission, meets the signal scheduling, distribution and management requirements of front and rear 8K, 4K, HD and new media signals for each channel, frequency and new media platform. This also opens up the front and rear ultra-large-scale signals transmission channels, to achieve CMG’s first application of full UHD signal production and broadcasting for outfield major sporting events.",
      },
      head2: {
        zh: "移动外场8K网络制播系统",
        en: "Mobile outfield 8K network production and broadcasting system",
      },
      body2: {
        zh: "总台移动外场8K网络制播系统构建了基于总台媒体云+北京国际广播中心边缘云的一体化转播架构，实现了8K采、编、播、存一体化的全IP前后场协同制播体系。并将首次采用基于JPEG-XS的编解码技术，可降低超高清制播系统建设成本，全面的推进国内超高清产业的建设发展。",
        en: "The CMG mobile outfield 8K network production and broadcasting system has created an integrated rebroadcasting architecture based on CMG Media Cloud + Beijing International Broadcasting Center Edge Cloud. It achieves an all-IP end-to-end collaborative production and broadcasting system through the integration of 8K acquisition, editing, broadcasting and storage. For the first time, it has adopted the JPEG-XS-based coding and decoding technology, which can reduce the construction costs of the UHD production and broadcasting system and comprehensively promote the construction and development of the domestic UHD industry.",
      },
      head3: {
        zh: "8K播出平台",
        en: "8K broadcasting platform",
      },
      body3: {
        zh: "总台8K超高清节目播出平台支持8K超高清文件录播和8K超高清信号直播的播出形式，具备多通道并行的节目播出能力，可支持多地域个性化编排播出。",
        en: "The CMG 8K UHD program broadcasting platform supports 8K UHD file recording and 8K UHD signal live broadcasting, with a multi-channel parallel broadcasting capability. It also allows for multi-territory personalized scheduling.",
      },
      head4: {
        zh: "8K超高清频道",
        en: "8K UHD channel",
      },
      body4: {
        zh: "1月24日，中央广播电视总台CCTV-8K超高清频道开播，“百城千屏”公共大屏项目同时启动。总台将携手各地方党委政府、四大电信运营商和相关企事业单位，共同推动 8K超高清频道进网入户和“百城千屏”项目落地，以超高清观看体验，奋力实现“科技冬奥·8K看奥运”。",
        en: "On January 24, CCTV-8K UHD channel of China Media Group (CMG) began broadcasting, and the “1,000 screens installed in 100 cities” public screen project was launched simultaneously. CMG will work together with local party committees and governments, four major telecom operators and related enterprises and institutions to promote the broadcasting of 8K UHD channel and the implementation of “1,000 screens installed in 100 cities” project, in a bid to achieve the “Technology and the Winter Olympics – Watching the Olympics in 8K UHD” with UHD watching experience.",
      },
      head5: {
        zh: "百城千屏项目",
        en: "1,000 Screens Installed in 100 Cities Project",
      },
      body5: {
        zh: "目前，“百城千屏”项目已启动建设的地区包括北京、上海、广东、浙江、湖北、福建、江西等12多个省市35个城市，在冬奥高铁专线上的清河、延庆、太子城、崇礼4个车站，已设置了8K超高清大屏播出总台8K超高清频道节目。在北京冬奥会期间，总台8K超高清频道在全国数百块超高清大屏同步播出。同时，观众可通过“百城千屏随声听”微信小程序收听到与8K超高清大屏同步的电视伴音。从而实现人们在户外大屏前享受超清、炫彩、真切的视听盛宴。",
        en: "The “1,000 screens installed in 100 cities” project has been launched in more than 10 provinces and municipalities directly under the central government, including Beijing, Shanghai, Guangdong, Zhejiang, Hubei, Jiangsu, Anhui, Sichuan, Shandong, Fujian and Jiangxi. 8K ultra-high definition screens have been set up in the four stations of Qinghe, Yanqing, Taizicheng and Chongli on the Winter Olympics high-speed railway line to broadcast the CCTV-8K ultra-high definition channel programs. During the 2022 Beijing Olympic Winter Games, the CCTV-8K ultra-high definition channel will also be integrated into the cable networks in Beijing and Guangdong, and broadcasted simultaneously on hundreds of ultra-high definition screens across the country.",
      },
    },
    {
      id: "03",
      name: {
        zh: "高铁5G超高清演播室",
        en: "5G Livestreaming Studio on High-speed Train",
        pic: "img/scene3/name.png",
      },
      icon: "icon-scene3",
      brief: {
        zh: "北京冬奥会期间，总台在京张高铁车厢内利用5G网络传输技术搭建超高清移动演播室（含导播室），实现对乘车运动员、官员、嘉宾的访谈，并在车头设置景观机位拍摄沿途画面，通过5G网络将超高清信号实时回传。",
        en: "For the Beijing Winter Olympics, the CMG has built an ultra-high-definition mobile studio (including a directing room) in the Beijing-Zhangjiakou high-speed train carriage by using 5G network transmission technology. This will be used to interview athletes, officials and guests. A landscape camera will also be set up at the head of the train to take pictures along the way and transmit ultra-high-definition signals back in real time through the 5G network.",
      },
      head1: {
        zh: "",
        en: "",
      },
      body1: {
        zh: "1月6日，由总台联合相关单位创新建设的高铁5G超高清演播室正式运行。这是全球首次在350公里时速的高铁列车上，依托5G技术打造超高清直播演播室，实现超高清信号的长时间稳定传输。",
        en: "On January 6, the innovative high-speed railway 5G ultra-high-definition studio, was officially put into operation. Globally, this is the first time that an ultra-high-definition live broadcasting studio has been built on a high-speed train, which hits speeds of 350 km/h. It relies on 5G technology, which can achieve a consistently stable transmission of ultra-high-definition signals.",
      },
      head2: {
        zh: "高铁5G超高清演播室",
        en: "5G Livestreaming Studio on High-speed Train",
      },
      body2: {
        zh: "",
        en: "",
      },
      head3: {
        zh: "",
        en: "",
      },
      body3: {
        zh: "北京2022年冬奥会和冬残奥会期间，部分媒体人员需从各竞赛场馆经常性往返京张两地的三个赛区，京张高铁为各方媒体及时进行快速报道提供有力支持。高铁5G移动超高清直播演播室将利用创新技术手段，为连接沟通各赛区、各场馆、各媒体提供新型服务渠道。",
        en: "During the 2022 Beijing Winter Olympics and Winter Paralympics, a number of media personnel will need to frequently travel to and from the three divisions in Beijing and Zhangjiakou to reach the various competition venues. The Beijing-Zhangjiakou high-speed train will provide adequate support for media outlets to create timely reports. The high-speed railway 5G mobile ultra-high-definition live broadcasting studio will leverage innovative technology to provide new service channels for connecting and communicating with various divisions, venues and media.",
      },
      head4: {
        zh: "",
        en: "",
      },
      body4: {
        zh: "利用5G传输超低时延特性，主持人和嘉宾即便相隔百余公里进行远程连线，也能在高铁5G超高清演播室里呈现效果逼真的同画面访谈。",
        en: "Using the ultra-low latency characteristics of 5G transmission, even if the host and guests are connected remotely at a distance of more than 100 kilometers, they can conduct live interviews or segments with the same picture quality while using the high-speed railway 5G ultra-high-definition studio.",
      },
    },
    {
      id: "04",
      name: {
        zh: "云端制作",
        en: "Production via Cloud Services",
        pic: "img/scene4/name.png",
      },
      icon: "icon-scene4",
      brief: {
        zh: "CMG媒体云-移动云制作系统采用 “云边端”技术架构，利用云端计算、数据和存储资源，结合总台边缘云节点、IBC工作区、ZBC工作区、总台专业制作区，形成多级协同制播体系，在北京冬奥会宣传报道中，提供融媒体环境下高效快捷的内容策划、采集、编辑、分发能力，解决前方报道就近生产、实时制作需求。",
        en: "The CMG Media Cloud-Mobile Cloud Production System adopts “cloud edge” technology architecture, utilizing cloud computing, data and storage resources, to form a multi-level collaborative production and broadcasting system comprised of the CMG edge cloud nodes, IBC workspace, ZBC workspace and the CMG professional production area. The system offers a fast and efficient platform for content planning, news gathering, editing and distribution of multi-media reports of the 2022 Beijing Olympic Winter Games. The system helps meet the needs of real-time editing for on-site reports of the Games.",
      },
      head1: {
        zh: "云端多节点素材管理",
        en: "Cloud Multi-node Material Management",
      },
      body1: {
        zh: "为实现“天地一体”化的云边端协同生产新模式，系统采用云端多节点素材管理功能的设计思路，以公有云为媒体汇聚平台，向下涵盖多个不同区域边缘节点，实现媒体资源统一汇总、统一查找和统一调用。",
        en: "The new cloud edge-end collaborative production mode of the “Space-Earth Integration Network” is achieved through the design concept of the cloud multi-node material management function in the system. It takes the public cloud as the media convergence platform and covers multiple edge nodes in different regions, with an aim to uniformly summarize, search and call media resources.",
      },
      head2: {
        zh: "移动化制作",
        en: "Mobile Production",
      },
      body2: {
        zh: "移动云制作系统主要由云媒体库、直播流编辑支撑服务、媒体稿件编辑系统、移动化制作能力服务中台（提供对素材后台转码、抽帧、渲染、合成等制作能力）四大系统模块组成，以提供移动端（手机/平板）在线编辑制作能力。同时，移动云制作系统可与线下超高清制作系统进行交互，可同步素材及剪辑工程文件。",
        en: "The mobile cloud production system is mainly composed of four system modules: the cloud media library, livestream editing support service system, media manuscript editing system, and mobile production support service center. This provides production capabilities such as material background transcoding, frame extracting, rendering and synthesis, allowing for online editing and production through a mobile terminal such as a smartphone or tablet. At the same time, it can collaborate with the offline ultra-high-definition production system, enabling material synchronization and engineering file editing.",
      },
      head3: {
        zh: "多终端协同制作",
        en: "Multi-terminal Collaborative Production",
      },
      body3: {
        zh: "外场拍摄或收录的素材，第一时间将低码素材文件上传到云端媒体库中，在存储介质中的高码素材传送回制作区前，编辑人员可以不受时间、地域的限制，通过互联网，利用移动编辑终端进行预览、挑选、剪切、拼接等粗编操作，输出故事板时间线文件到移动云制作系统。待高码素材上载至制作区后，编辑人员从云端资源库同步故事板时间线文件到本地非编工作站加载，即可实现粗编时间线快速套片流程，节省高码素材二次挑选时间，提高节目生产效率。",
        en: "For footage shot or recorded in the field, the low-bit rate material file can be immediately uploaded to the cloud media library. The high-bit rate material in the storage media can be transmitted back to the production area. Editors can use the mobile editing terminal for preview, selection, cutting, splicing and other rough editing operations through the Internet, and can also output the storyboard timeline file to the mobile cloud production system. After the high-bit rate material is uploaded to the production area, editors can load the storyboard timeline file synchronously from the cloud resource library to the local non-linear editing workstation. This can achieve a fast film-setting process for the rough-edited timeline, saving time for the secondary selection of other high-bit rate material and improve the overall program production efficiency.",
      },
      head4: {
        zh: "云导播台",
        en: "Cloud Directing System",
      },
      body4: {
        zh: "云导播台技术是基于公有云服务的B/S架构导播制作工具，支持多终端推流信号接入，使用电脑浏览器即可进行导切、调音、包装等操作。云导播台支持低延时视频传输协议、移动云连线等功能。云导播后台管理系统支持主备云导播台、直播延时及应急切换等功能。",
        en: "The cloud directing system technology features a B/S architecture directing production tool based on public cloud services that allows for multi-terminal stream signal access and can be used for directed cutting, tuning, packaging and other operations through a computer browser. The cloud directing system supports low-latency video transmission protocol, mobile cloud connection and other functions. The cloud directing background management system supports main and standby cloud directing systems, live broadcasting delay,<br> emergency switching and other functions.",
      },
      head5: {
        zh: "云连线",
        en: "Cloud Connection",
      },
      body5: {
        zh: "移动云连线服务部署在公有云平台，在5G网络环境下，节目制作人员通过手机UGC APP、网页链接、摄像机和RTC连线盒等多种方式，低延时访问移动云连线服务，将前方连线画面回传至演播室与演播室主持人进行实时连线互动问答。",
        en: "The mobile cloud connection service is deployed on the public cloud platform. In the 5G network environment, program producers can access mobile cloud connection service with low latency through the mobile UGC APP, web links, camera, RTC connection box, etc. The images from the front connection screen can be sent back to the studio for real-time interactive Q&A with the studio host.",
      },
    },
    {
      id: "05",
      name: {
        zh: "全媒体传播",
        en: "Convergence Media Communication",
        pic: "img/scene5/name.png",
      },
      icon: "",
      brief: {
        zh: "根据总台“5G+4K/8K+AI”战略布局，新媒体集成发布平台为总台新媒体业务提供汇聚、调度、内容管理和分发能力，全面支撑央视频、央视新闻、垂直客户端、第三方直播等新媒体节目生产。<br>北京冬奥会期间，集成发布平台在新媒体直播、点播及新媒体产品等方面提供了全方位的技术支持，首次支撑大规模VR赛事直播，并全面对接官方赛事数据平台，为体育赛事的新媒体业务提供强有力的保障手段。",
        en: "According to the  China Media Group’s (CMG) “5G+4K/8K+AI” strategic layout, the  integrated publishing platform for new media  will enhance content aggregation, scheduling, management and distribution capabilities, It will fully support the production of new media programs at terminals, including CCTV Video Agency, CCTV News, vertical client and third-party live broadcasting platforms.<br>During the Beijing 2022 Olympic and Paralympic Winter Games, the new media integrated publishing platform will provide comprehensive technical support in live broadcasting, on-demand broadcasting and new media products. It also supports the live broadcasting of large-scale VR events for the first time and is fully connected to the official event data platform, which strengthens the reporting for the new media business of sporting events.",
      },
      title1: {
        zh: "自主选择声道",
        en: "3D Audio",
      },
      title2: {
        zh: "播放三维声",
        en: "Playing 3D audio",
      },
      head1: {
        zh: "汇聚调度",
        en: "Aggregation and Scheduling",
      },
      body1: {
        zh: "集成发布平台可对来自总控、演播室、背包、互联网第三方等多种不同赛事的直播流信源进行统一汇聚，通过AI技审和安播服务对技术参数进行预警和标准化处理，并根据用户的网络情况，利用CDN服务进行分发。",
        en: "The new media integrated publishing platform can uniformly gather  live streaming sources, which will involve  a master control system, studio, backpack and third parties on the Internet. It will conduct early warning and standardization of technology parameters through AI technology review and safe-broadcasting services, distributing them with CDN services according to the users’ network conditions.",
      },
      head2: {
        zh: "移动直播",
        en: "Mobile Live Video Broadcasting",
      },
      body2: {
        zh: "对于移动化的新媒体内容生产，魔兔工具客户端可围绕2022冬奥会的新媒体直播建立手机端生产环境，并提供一键直播、直播任务下单、视频剪辑、内容审核、直播流监看等主要能力。",
        en: "For new media content production across mobile devices, the Wererabbit client can build a mobile production environment around the new media live broadcasting of the Beijing 2022 Olympic and Paralympic Winter Games. This will allow for one-click live broadcasting, live broadcasting task order placing, video editing, content review, live broadcasting channel monitoring, etc.",
      },
      head3: {
        zh: "直播任务单",
        en: "Live broadcasting task list",
      },
      body3: {
        zh: "实现了总台一单通，新建直播任务单可以调用所有常用信源输出到新媒体客户端进行分发。",
        en: "It realized the All-in-list function throughout the CMG, and the new live broadcasting task list can call all common source outputs to the new media client for distribution.",
      },
      head4: {
        zh: "视频制作",
        en: "Video production",
      },
      body4: {
        zh: "集成专业视频制作能力、支持多种素材选取方式，提供移动式短视频制作工具。",
        en: "It integrates professional video production capabilities, supports a variety of material selection methods, and provides mobile short video production tools.",
      },
      head5: {
        zh: "内容审核",
        en: "Content review",
      },
      body5: {
        zh: "依托新媒体集成发布平台、央视频视频中台现有的审核能力，实现移动式客户端内容审核。",
        en: "Relying on new media integrated publishing platform and existing review capabilities of China Media Group Mobile, it realized mobile client content review.",
      },
      head6: {
        zh: "一键直播",
        en: "One-click live broadcasting",
      },
      body6: {
        zh: "通过配置快速直播模板，对于突发性直播，可一键推送至新媒体客户端进行分发。",
        en: "By configuring the fast live broadcasting template, we can push the sudden live broadcasting to the new media client for distribution.",
      },
      head7: {
        zh: "监看",
        en: "Monitoring",
      },
      body7: {
        zh: "提供安全、灵活的多样化监看能力，实现新媒体节目的安全分发与播控。",
        en: "It boasts safe, flexible and diversified monitoring capabilities, realizing the safe distribution and broadcasting control of new media programs.",
      },
      head8: {
        zh: "三维声",
        en: "3D Audio",
      },
      body8: {
        zh: "集成发布平台为冬奥赛事直播提供了同一直播流在三维声、无解说三维声及普通立体声三个音轨间切换的功能，为用户提供了更多样的观赛选择和体验。",
        en: "During the Winter Olympics, the new media integrated publishing platform will facilitate switching of the live broadcasting stream across three tracks: 3D audio, 3D audio without commentary and ordinary stereo sound. This will present users with more choices and unique experiences while watching the competitions.",
      },
      head9: {
        zh: "VR直播",
        en: "VR Live Broadcasting",
      },
      body9: {
        zh: "北京冬奥期间，新媒体集成发布平台可支撑多场次的VR赛事直播，使用户有着身临其境的观赛体验，这是首次在国际重大体育赛事中大规模使用VR直播技术。",
        en: "The new media integrated publishing platform can support VR live broadcasting of multiple events for users to have an immersive viewing experience. This is the first large-scale use of VR live broadcasting technology at a major international sport event.",
      },
      head10: {
        zh: "赛事数据",
        en: "Event Data",
      },
      body10: {
        zh: "通过自建的专业赛事数据平台，新媒体集成发布平台全面对接官方赛事数据，为演播室、央视频客户端、央视体育客户端和第三方渠道输出覆盖赛程、奖牌榜、运动员及代表团信息等方面的赛事数据，为体育类产品的制作提供了有力的数据支持和技术保障。",
        en: "Through its professional event data platform, the new media integrated publishing platform connects with official event data  of full information on the schedule, medal list, athletes and delegation information for studios, C5 app and third party channels. This provides strong data and technology support for the production of sports products.",
      },
    },
  ],

  popup2_1: [
    {
      head: {
        zh: "超高清信号制作",
        en: "UHD signal production",
      },
      body: {
        zh: "北京冬奥会前场转播，总控系统从与OBS公共信号的对接，到所有TV compound、外景演播室、单边摄像机、混合区，IBC制播系统，已全部采用超高清信号进行制作。同时打通4K、8K超高清信号JPEG-XS编码压缩方式的全台跨系统、跨域的信号传输和交接瓶颈，探索了符合总台技术路线的8K超高清制播模式。",
        en: "For the front-end broadcasting of the Beijing Winter Olympics, the master control system utilizes UHD signals to produce the connection from the OBS public signal to all TV compounds, exterior studios, single-sided cameras, mixed-use areas, and IBC production systems. At the same time, it breaks the bottleneck of cross-system and cross-domain signal transmission and the handover of 4K and 8K UHD signal JPEG-XS encoding and compression. The 8K UHD production and broadcasting mode is also explored in line with the CMG technical route.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_1_1.png",
          en: "img/scene2/popup2_1_1-en.png",
        },
      ],
    },
    {
      head: {
        zh: "信号传输和分发全流程IP化应用",
        en: "Full process for the IP-based application of signal transmission and distribution",
      },
      body: {
        zh: "全面推进IP化制播应用，从与OBS的信号和OBS所有外场传输线路的对接，IBC/ZBC总控核心调度分发系统、与IBC/ZBC台内演播室和收录系统的交互，以及信号从IBC回台传输，全链路全流程采用IP化制播，实现总控信号传输、调度和分发全流程IP化。",
        en: "To comprehensively promote the IP-based production and broadcasting application of the next generation of radio and television, the entire process utilizes IP-based production and broadcasting. This achieves an overall IP-based transmission, scheduling and distribution of the master control signal, which extends from the first UHD public signal IP connection with OBS, to the IP connection of outfield transmission lines, IBC/ZBC master control core scheduling and distribution system, and interaction with IBC/ZBC studio and recording systems, as well as the signal transmission from IBC back to the station.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_1_2.jpg",
          en: "img/scene2/popup2_1_2-en.jpg",
        },
      ],
    },
    {
      head: {
        zh: "超大规模前后场信号传输和前后场一体化制播",
        en: "Ultra-large-scale end-to-end signal transmission and integrated end-to-end production and broadcasting",
      },
      body: {
        zh: "在IBC进行前场所有8K、4K、高清和新媒体流信号汇聚后，通过建设超大带宽OTN传输系统，直接对接前场IP调度分发系统和后场总控台内核心调度系统，打通面向总台各个制播平台的超大规模信号传输链路，联通前后场基础网络传输通路，形成信号、文件的前后场充分资源共享，建设内外场一体化的制播环境。",
        en: "Once all 8K, 4K, HD and new media stream signals are converged on the front end at IBC, the ultra-large bandwidth OTN transmission system is built to directly connect to the IP scheduling and distribution system on the front end and the core scheduling system on the back end master console. This will open up the ultra-large-scale signal transmission link for each CMG production and broadcasting platform, connect the basic network transmission paths in the front and back ends, create end-to-end full signal resource sharing, and build an integrated production and broadcasting environment for the inner and outer areas. ",
      },
      pic: [
        {
          zh: "img/scene2/popup2_1_3.png",
          en: "img/scene2/popup2_1_3-en.png",
        },
      ],
    },
    {
      head: {
        zh: "国产化自主知识产权总控调度分发系统实践",
        en: "Practice of domestic master control scheduling and distribution system with independent intellectual property rights",
      },
      body: {
        zh: "IBC总控超高清信号跨域信号传输和调度分发平台为全国产化、自主知识产权的调度分发系统，采用全域组播信号NAT地址转换、全媒体大带宽信号实时分发方案，采用PTP容错和防抖动等技术，实现高精度、高可靠的信号，并通过智能化SDN控管监软件系统实现基于业务要求的信号调度精准管控。",
        en: "The IBC master control UHD cross-domain signal transmission and scheduling distribution platform is a fully localized scheduling and distribution system with independent intellectual property rights. It adopts NAT address conversion for all-domain multicast signals, a real-time distribution scheme for all-media large-bandwidth signals, PTP fault tolerance and anti-jitter technologies and the intelligent SDN control method to achieve precise control of signal scheduling based on service requirements, and transform CMG’s scientific research achievements into actual productivity.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_1_4.png",
          en: "img/scene2/popup2_1_4-en.png",
        },
      ],
    },
  ],
  popup2_2: [
    {
      head: {
        zh: "信号收录采集",
        en: "Signal recording and acquisition",
      },
      body: {
        zh: "该系统在2022北京冬奥会IBC配备了5台8K超高清收录终端用作前场8K超高清信号收录。收录终端与上游总控系统采用SMPTE 2110 IP传输方式进行信号交接，信号制式为7680*4320 50P HDR Rec.2020/HLG，收录文件采用JPEG-XS编码方式，封装为MXF格式的视音频合一文件。",
        en: "The system is equipped with five sets of 8K UHD recording terminals at IBC for front-end recording of 8K UHD signals of the Beijing Winter Olympics. The recording terminals and upstream master control system use SMPTE 2110 IP transmission for signal handover. The signal standard is 7680*4320 50P HDR Rec.2020/HLG. Recording files adopt the JPEG-XS encoding method and are encapsulated as a unified MXF-format video and audio file.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_2_1.jpg",
          en: "img/scene2/popup2_2_1-en.jpg",
        },
      ],
    },
    {
      head: {
        zh: "编辑制作",
        en: "Editing and production",
      },
      body: {
        zh: "8K超高清编辑终端具备专业的时间线编辑功能，对业内主流的UHD格式全兼容，支持索尼、松下、佳能、阿莱、大疆等各品牌摄像机的拍摄录制文件。通过优化编解码算法在保证上监能力的同时，实现剪辑上的高实时性。同时，预创的8K HDR时间线支持8K JPEG-XS等多种视频格式上线，将不同编码格式、不同分辨率、不同色彩空间的素材统一展现，实现所见即所得的效果。",
        en: "The 8K UHD editing terminal is equipped with professional timeline editing functions that are fully compatible with the industry’s mainstream UHD formats. It supports the shooting and recording files for Sony, Panasonic, Canon, ARRI, DJI and other camera brands. By optimizing the codec algorithm to ensure the monitoring ability, it achieves a high level of real-time editing. At the same time, the previously established 8K HDR timeline supports 8K JPEG-XS and other video formats online, unifying the presentation of different coding formats, different resolutions and different color spaces of the material to achieve the WYSIWYG effect.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_2_2.jpg",
          en: "img/scene2/popup2_2_2.jpg",
        },
      ],
    },
    {
      head: {
        zh: "文件化送播",
        en: "File-based broadcast submission",
      },
      body: {
        zh: "编辑完成的8K成品节目及8K素材，通过IBC边缘云到总台中心云的专有链路回传总台中心云-光华路办公区，实现面向总台8K超高清频道的节目备播及面向央视专区的8K点播节目分发。",
        en: "The edited 8K programs and 8K materials are transmitted back to the CMG Central Cloud-Guanghua Road Office Zone through a proprietary link from IBC Edge Cloud. This is done to complete program preparation for the CMG 8K UHD channel and 8K on-demand program distribution for the CCTV Zone.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_2_3.jpg",
          en: "img/scene2/popup2_2_3-en.jpg",
        },
      ],
    },
  ],
  popup2_3: [
    {
      head: {
        zh: "",
        en: "",
      },
      body: {
        zh: "8K超高清节目播出平台包括业务应用服务和基础平台支撑系统。该平台可依照播出单据完成8K超高清节目文件的自动化备播流程，实现对8K超高清播出视频服务器的文件解码播出、信号切换与图文包装叠加播出等功能的自动化控制，以及完成对视音频信号系统的调度控制。",
        en: "The 8K UHD program broadcasting platform includes business application services and a basic platform support system. The platform can complete the automated preparation process for 8K UHD program files in accordance with broadcasting documents. It can also realize the automated control of file decoding broadcasting, signal switching and graphic packaging overlay broadcasting for 8K UHD broadcasting video servers, as well as complete the scheduling control for the video and audio signal system.",
      },
      pic: [
        {
          zh: "img/scene2/popup2_3_1.jpg",
          en: "img/scene2/popup2_3_1-en.jpg",
        },
        {
          zh: "img/scene2/popup2_3_2.jpg",
          en: "img/scene2/popup2_3_2.jpg",
        },
      ],
    },
    {
      head: {
        zh: "",
        en: "",
      },
      body: {
        zh: "该平台在“相约北京”冬奥会测试赛期间首次实现外场转播制作的8K超高清信号的全要素直播节目播出试验，系统信号实现IP化，支持8K超高清实时信号的可靠播出，为北京冬奥会的赛事转播积累了丰富的实践经验。",
        en: "During the “Experience Beijing” - A Series of Winter Sporting Events, the platform achieved a full 8K UHD signal live broadcast test produced by the outfield broadcasting team for the first time. The system signal was IP-based, which supported the reliable broadcasting of 8K UHD real-time signals and accumulated extensive practical experience for broadcasting the Beijing Winter Olympics.",
      },
      pic: [],
    },
  ],

  continue: {
    zh: "",
    en: "",
  },
  vr: {
    zh: "VR高清",
    en: "VR HD",
  },
  detail: {
    zh: "详细介绍",
    en: "Detailed introduction",
  },
};
